import {streamFromService} from "@breachrx/streaming";

const getRexAIBaseURL = () => {
  return process.env.REXAI_API || "http://localhost:4003";
};

export const streamRegulations = async function* (request, options = {}) {
  const {prompt, email, sessionId, userName, timezone} = request;
  const {signal, authToken} = options;

  yield* streamFromService(
    `${getRexAIBaseURL()}/v1/regulations/stream`,
    {prompt, email, sessionId, userName, timezone, modelProfile: "global-claude"},
    {
      signal,
      headers: {
        Authorization: `Bearer ${authToken}`,
        "X-Client-Platform": "web",
      },
    },
  );
};
